module.exports = __webpack_public_path__ + "static/img/banner-oportunidades-home-768x1024.845d5fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-oportunidades-home-768x1024.jpg
// module id = MN7b
// module chunks = 47